import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const outsourcingFilterLabel = () => t({ message: 'Outsourcing', comment: 'Insights: Outsourcing filter' });
export function OutsourcingFilter() {
    return <BooleanFilter name="metadataDocumentOutsourcing" label={outsourcingFilterLabel()}/>;
}
